module.exports = __webpack_public_path__ + "img/founders_3.eb8058f6.jpg";